import { render, staticRenderFns } from "./weekly-add-or-update.vue?vue&type=template&id=b7cd2816&scoped=true"
import script from "./weekly-add-or-update.vue?vue&type=script&lang=js"
export * from "./weekly-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./weekly-add-or-update.vue?vue&type=style&index=0&id=b7cd2816&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cd2816",
  null
  
)

export default component.exports